<template>
    <div>
        <div ref="currentTime"></div>
        <div ref="timeDivider"></div>
        <div ref="durationTime"></div>
    </div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';

export default {
    name: 'SbsVideoPlayerTimeDisplay',
    inject: {
        videoPlayerComponent: { default: null },
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
    },
    mounted() {
        const CurrentTimeDisplay = videojs.getComponent('currentTimeDisplay');
        const TimeDivider = videojs.getComponent('timeDivider');
        const DurationTime = videojs.getComponent('durationDisplay');
        const currentTimeDisplayComponent = new CurrentTimeDisplay(this.player);
        const timeDividerComponent = new TimeDivider(this.player);
        const durationTimeComponent = new DurationTime(this.player);
        const currentTime = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.currentTime,
        });
        const timeDivider = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.timeDivider,
        });
        const durationTime = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.durationTime,
        });

        currentTime.addChild(currentTimeDisplayComponent);
        timeDivider.addChild(timeDividerComponent);
        durationTime.addChild(durationTimeComponent);
    },
};
</script>

<style lang="scss">
.vjs-time-control {
    .video-js .vjs-control-bar & {
        padding-right: 0;
        padding-left: 0;
        text-align: center;
    }

    &.vjs-current-time.vjs-control {
        display: block;
    }

    &.vjs-time-divider {
        display: block;
        color: $gray-light;

        .video-js .vjs-control-bar & {
            min-width: 0;
            padding: 0 3px;
        }
    }

    &.vjs-duration.vjs-control {
        display: block;

        .vjs-duration-display {
            color: $gray-light;
        }
    }
}
</style>
